import {
  SEARCH_USERS_REQUEST,
  SEND_MESSAGES_REQUEST,
  clearComposePage,
  clearUsers,
  searchUsersSuccess,
  setUsersLoading
} from './composeActions';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { getMessageRequests, getUserSearch } from './composeSelectors';
import { delay } from 'redux-saga';
import { getAuth } from 'actions/auth/login';
import { getClientCode } from 'actions/ui/init/initSelectors';
import { getLocale } from 'actions/language/selectors';
import { push } from 'react-router-redux';
import { pushAttentionNotification } from 'actions/notification/notification';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';
import { searchUsers } from 'api/messages';

/*** Fetch Users ***/
// Worker
export function* searchUsersWorker() {
  try {
    yield put(clearUsers());
    yield call(delay, 500);
    yield put(setUsersLoading(true));
    const searchTerm = yield select(getUserSearch);
    const locale = yield select(getLocale);
    const auth = yield select(getAuth);
    const data = yield call(searchUsers, locale, auth, searchTerm);
    yield put(searchUsersSuccess(data.users));
    yield put(setUsersLoading(false));
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* searchUsersSaga() {
  yield takeLatest(SEARCH_USERS_REQUEST, searchUsersWorker);
}

/*** Send Message ***/
// Worker
export function* sendMessageWorker() {
  try {
    const requests = yield select(getMessageRequests);
    if (!requests.length) throw Error('Pick a delivery Method');
    yield all(requests);
    const locale = yield select(getLocale);
    const clientCode = yield select(getClientCode);
    yield put(
      pushAttentionNotification({
        title: 'Success',
        messages: `Message${requests.length > 1 ? 's' : ''} Sent`
      })
    );
    yield put(push(`/${locale}/${clientCode}/communication/messages`));
    yield put(clearComposePage());
  } catch (err) {
    yield pushFormattedError(err);
  }
}

// Watcher
export function* sendMessageSaga() {
  yield takeLatest(SEND_MESSAGES_REQUEST, sendMessageWorker);
}



// WEBPACK FOOTER //
// ./src/actions/communication/compose/composeSagas.js